<template>
	<div>
		<div class="top-nav">
			<div></div>
			<div class="flex flex-col-center">
				<div style="margin-top: 5px;"><el-avatar size="small" :src="circleUrl"></el-avatar></div>
				<div class="right-drop">
					<el-dropdown>
					  <span class="el-dropdown-link">
					    {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <!-- <el-dropdown-item>修改密码</el-dropdown-item> -->
					    <el-dropdown-item><span @click="loginOut">登出</span></el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "TopBar",
		props: {},
		data() {
			return {
        realname:'',
        name:'',
				role:{},
				circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
			}
		},
		created() {
			this.role = sessionStorage.getItem("role");
			this.role = JSON.parse(this.role);
      this.realname = sessionStorage.getItem('realname');
      this.name = sessionStorage.getItem('name')+'['+sessionStorage.getItem('username')+']';
		},
		methods: {
			loginOut(){
				sessionStorage.clear();
				this.$router.push({
					path:"/Login"
				})
			},

			changeFoundPwd(){
				this.$request({
					url:this.$api.base.changeFoundPwd,
					method:"post",
					data:{value:this.foundPwd}
				}).then((res)=>{
					if(res.data.code==1){
						this.$message.success(res.data.msg);
					}else{
						this.$message.error(res.data.msg);
					}
				}).catch(()=>{
					this.$message.error("请求失败")
				})
			},
		}
	}
</script>

<style scoped>
	.top-nav{
		height: 59px;
		width: 100%;
		background-color: #FFF;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #e3e3e3;
	}

	.el-fold{
		margin-left: 30px;
		font-size: 24px;
		color: #666;
		cursor: pointer;
	}

	.found-pwd{
		margin-right: 20px;
		font-size: 14px;
	}

	.right-drop{
		margin-left:10px;
		margin-right: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/TopBar.vue